import {
  alpha,
  styled,
  Table,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from '@mui/material';

export const CategoryTitle = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  fontWeight: 600,
  textTransform: 'uppercase',
  letterSpacing: '0.7px',
  color: theme.palette.primary.main,
  margin: '16px 0 8px',
}));

export const StyledTableContainer = styled(TableContainer)(() => ({
  borderTopLeftRadius: 6,
  borderTopRightRadius: 6,
}));

export const StyledTable = styled(Table)(({ theme }) => ({
  '& .MuiTableHead-root': {
    backgroundColor: theme.palette.secondary.light,
  },
}));

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  border: `1px solid ${alpha(theme.palette.common.grey, 0.3)}`,
}));

export const StyledHeaderTableRow = styled(TableRow)(({ theme }) => ({
  border: `1px solid ${alpha(theme.palette.common.grey, 0.3)}`,
  borderTopLeftRadius: 6,
  borderTopRightRadius: 6,
}));
